import { render } from "./claimcategories.vue?vue&type=template&id=46822f45&lang=html"
import script from "./claimcategories.vue?vue&type=script&lang=js"
export * from "./claimcategories.vue?vue&type=script&lang=js"

import "./claimcategories.vue?vue&type=style&index=0&id=46822f45&lang=less"

import exportComponent from "/opt/nexus/frontend/v1/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__